define('plugin/invoice/model/InvoicePromotionInstanceModel',['require','backbone'],function (require) {

    var Backbone = require('backbone');

    /**
     * Invoice promotion instance model
     *
     * @class InvoicePromotionInstanceModel
     */
    return Backbone.Model.extend({

        defaults: {
            id: null,
            promotion: null,
            can_be_used: true,
            code: '',
            is_used: false
        }

    });

});
